import type { RouteLocationNormalized } from 'vue-router';
import { useAccountStore } from '@/stores/account';
import { useWalletStore } from '@/stores/wallet';
import { verifyWalletAndCardTerms } from '../helpers/routeBefore';
import { EXTERNAL_USER_LEVEL } from '@/shared/common/constants/userLevels.constant';

export const validateWalletAndTerms = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized
) => {
  // Si la ruta no requiere autenticación, no es necesario validar wallet/términos
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    return true;
  }

  const storeAccount = useAccountStore();

  // Si el usuario es externo, no es necesario validar wallet/términos
  if (storeAccount.getLevel === EXTERNAL_USER_LEVEL) return true;

  const storeWallet = useWalletStore();

  // Verificar wallet y términos de tarjeta
  const walletRedirect = await verifyWalletAndCardTerms(
    storeAccount,
    storeWallet,
    to,
    from
  );
  if (walletRedirect) {
    return walletRedirect;
  }

  return true;
};
